import { render, staticRenderFns } from "./mbWeldCloud.vue?vue&type=template&id=3c48e7e6&scoped=true"
import script from "./mbWeldCloud.vue?vue&type=script&lang=js"
export * from "./mbWeldCloud.vue?vue&type=script&lang=js"
import style0 from "./mbWeldCloud.vue?vue&type=style&index=0&id=3c48e7e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c48e7e6",
  null
  
)

export default component.exports